import React from 'react';
import { observer } from 'mobx-react';
import GroupDeleteComponent from './Group-delete.component';
import useGroupDelete from './useGroupDelete';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { groups, lang, state, handlers } = useGroupDelete(onClose);

    return (
        <>
            <GroupDeleteComponent
                lang={lang.lang}
                loading={groups.deleteGroupLoading || groups.loading}
                groupName={state.groupName}
                serverError={groups.serverError}
                onConfirmClick={handlers.handleConfirmClick}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onCancelClick={onClose}
            />
        </>
    );
};

const GroupDeleteContainer = observer(Container);

export default GroupDeleteContainer;
